import { getCustomer, getCustomerByPartyID } from "./db";

export const loadFromBase = async (baseLookup, notifier) => {
  const lookedUp = await getCustomer(baseLookup);
  if (lookedUp.data.customerResponsesByCodeBase?.items.length > 0) {
    return lookedUp.data.customerResponsesByCodeBase.items[0];
  } else {
    console.log("customer data failure: %o", lookedUp);
    return undefined;
  }
};

export const loadLatestFromBase = async (baseLookup, notifier) => {
  const lookedUp = await getCustomerByPartyID(baseLookup, true);
  if (lookedUp.data.customerResponsesByPartyID?.items.length > 0) {
    return lookedUp.data.customerResponsesByPartyID.items[0];
  } else if (lookedUp.data.customerResponsesByPartyID?.items.length == 0) {
    // LAN-110 introduced the PartyID (hash of DOB + Passport No. + Passport origin + Arrival Date)
    // For all old entries, lookup should be based on QRCodeBase
    return loadFromBase(baseLookup);
  } else {
    console.log("customer data failure: %o", lookedUp);
    return undefined;
  }
};
